import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module

import app from './modules/app'

import * as getters from './getters'

Vue.use(Vuex)

import saldo from './modules/saldo'

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    saldo
  },
  state: {},
  mutations: {}
})

Vue.use(VuexI18n.plugin, store)

export default store
